import { Banner } from './types';

export const SET_BANNERS = 'banners/SET_BANNERS';

export type SetBannersAction = {
	type: typeof SET_BANNERS;
	payload: {
		banners: Banner[];
		lastFetched: number | null;
	};
};

export const setBanners = ({
	banners,
	lastFetched,
}: {
	banners: Banner[];
	lastFetched: number | null;
}): SetBannersAction => ({
	type: SET_BANNERS,
	payload: {
		banners,
		lastFetched,
	},
});
